export default __webpack_public_path__ + "static/media/working-new-2.04dca26b.png";